import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseFormControlComponent } from '../../../shared/components/base-form-control/base-form-control.component';
import { ValidityIconComponent } from '../../../shared/components/validity-icon/validity-icon.component';
import { FormControlDirective } from '../../../shared/directives/form-control/form-control.directive';
import { NumericInputDirective } from '../../../shared/directives/numeric-input/numeric-input.directive';

@Component({
  selector: 'app-form-sortcode-single-input',
  imports: [
    NumericInputDirective,
    FormControlDirective,
    ReactiveFormsModule,
    ValidityIconComponent,
  ],
  providers: [
    {
      provide: BaseFormControlComponent,
      useExisting: forwardRef(() => SortcodeSingleInputComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sortcode-single-input.component.html',
  styleUrl: './sortcode-single-input.component.scss',
})
export class SortcodeSingleInputComponent extends BaseFormControlComponent<string> {
  sortcode = signal('');

  onSortCodeChange(event: Event) {
    const inputEvent = event as InputEvent;
    const target = inputEvent.target as HTMLInputElement;
    const prevCursorPos = target.selectionStart ?? 0;
    const sortCodeStripped: string = target.value.replaceAll('-', '');

    this.setValue(sortCodeStripped);

    const sortcode1 = sortCodeStripped.slice(0, 2);
    const sortcode2 = sortCodeStripped.slice(2, 4);
    const sortcode3 = sortCodeStripped.slice(4, 6);

    const formattedValue =
      sortcode1 +
      (sortcode2 !== ''
        ? '-' + sortcode2 + (sortcode3 !== '' ? '-' + sortcode3 : '')
        : '');

    target.value = formattedValue;

    const cursorPos =
      inputEvent.inputType == 'insertText' &&
      (formattedValue.length == 4 || formattedValue.length == 7) // skip forward when writing to 4th and 7th char (dashes)
        ? prevCursorPos + 1
        : prevCursorPos;

    target.setSelectionRange(cursorPos, cursorPos);
  }
}
